import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  TextField,
  Typography,
  Button,
  Tabs,
  Tab,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  FormControl,
  InputLabel,
  Select,
  Chip,
  MenuItem,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import Pagination from "@mui/material/Pagination";
import DeleteIcon from "@mui/icons-material/Delete";
import { buildMedia } from "../../Utils/AuthService";
import { fetchLanguages } from "../../../redux/slices/superAdmin/languagesSlice";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FilterButton from "./Components/FilterButton";
import { fetchCategories } from "../../../redux/slices/orgAdmin/categoriesOrgSlice";
import { rowsPerPage } from "../../../Constants";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { styled } from "@mui/material/styles";
import { useSelector, useDispatch } from "react-redux";
import Attachments from "./Utils/Attachments";
import {
  StyledButton,
  StyledContainer,
  StyledTableCell,
} from "../../CSS/Styles";
import {
  fetchEvents,
  saveEvent,
} from "../../../redux/slices/orgAdmin/eventSlice";
import {
  fetchLaws,
  getLaw,
  saveLaw,
} from "../../../redux/slices/orgAdmin/lawsSlice";
import { deleteSectionData } from "../../../redux/slices/orgAdmin/promotionsSlice";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export default function Laws() {
  const dispatch = useDispatch();
  const { lawsList, loading } = useSelector((state) => state.laws);
  const { languagesList } = useSelector((state) => state.languages);
  const { companyId } = useSelector((state) => state.app);
  const [deleteTitle, setDeleteTitle] = useState("");
  const { categories } = useSelector((state) => state.categories);
  const [selectedCategories, setSelectedCategories] = useState();
  const [media, setMedia] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [promotionIdToDelete, setPromotionIdToDelete] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  const sectionId = 7;
  const files = {};

  const [rowToEdit, setRowToEdit] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const [page, setPage] = useState(1);
  const totalRecords = lawsList?.pagination?.totalRecords || lawsList.length;
  const totalPages = Math.ceil(totalRecords / rowsPerPage);

  const [selectedCategoriesEDIT, setSelectedCategoriesEDIT] = useState();

  const defaultLanguage =
    languagesList.find(
      (lang) => lang.is_default === 1 || lang.is_default === "1"
    )?.code || "en";

  const [currentLanguage, setCurrentLanguage] = useState(defaultLanguage);

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleCategoryChange = (event) => {
    if (isEditing) {
      setSelectedCategoriesEDIT(event.target.value);
      setSelectedCategory(event.target.value.category_name);
    } else {
      setSelectedCategories(event.target.value);
    }
  };

  useEffect(() => {
    dispatch(fetchLaws({ companyId, page, limit: rowsPerPage }));
    dispatch(fetchLanguages());
    setSelectedCategories();
  }, [dispatch, companyId, page]);

  useEffect(() => {
    dispatch(fetchCategories({ companyId, sectionId }));
    if (!languagesList?.length) {
      dispatch(fetchLanguages());
    }
  }, [dispatch, sectionId, page]);

  const [isAddingTeam, setIsAddingTeam] = useState(false);

  const [newEvent, setNewEvent] = useState({
    ar: { title: "", description: "", country: "", year: null },
    // attachments: null,
  });
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);

  const handleInputChange = (language, field, value) => {
    setNewEvent((prev) => ({
      ...prev,
      [language]: {
        ...prev[language],
        [field]: field === "year" ? parseInt(value, 10) || null : value,
      },
    }));
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setNewEvent((prev) => ({ ...prev, attachment: file }));
    }
  };

  const handleEditLaw = async (id) => {
    try {
      setRowToEdit(id);
      setIsEditing(true);
      const actualId = id && typeof id === "object" ? id.id : id;

      const lawData = await dispatch(getLaw({ id: actualId })).then(
        (res) => res.payload
      );

      if (
        lawData?.status === "error" &&
        lawData.message === "Record not found"
      ) {
        alert("Record not found.");
        return;
      }

      if (!lawData || lawData.length === 0) {
        console.error("No law data found.");
        return;
      }

      const lawItem = lawData[0];
      const eventId = lawItem?.id || null;
      const mainImage = lawItem?.mainImage || "";

      // Extract available languages
      const availableLanguages = lawItem?.availableLanguages
        ? lawItem.availableLanguages?.split(",").map((lang) => lang.trim())
        : ["en", "fr", "ar"];

      const attachments = availableLanguages?.map((lang) => ({
        languageId: lang,
        fileName: lawItem?.attachment || null,
      }));
      setSelectedCategory(lawItem?.category_name);
      setSelectedCategoriesEDIT(lawItem?.fk_categoryId);
      const mediaData = buildMedia(companyId, eventId, mainImage, attachments);
      setMedia(mediaData);

      const prefilledLaw = {
        id: lawItem?.id || null,
        en: {
          title: lawItem?.title || "",
          description: lawItem?.description || "",
          country: lawItem?.country || "",
          year: lawItem?.year || null,
          fk_categoryId: lawItem.fk_categoryId || null,
        },
        fr: {
          title: lawItem?.title || "",
          description: lawItem?.description || "",
          country: lawItem?.country || "",
          year: lawItem?.year || null,
          fk_categoryId: lawItem.fk_categoryId || null,
        },
        ar: {
          title: lawItem?.title || "",
          description: lawItem?.description || "",
          country: lawItem?.country || "",
          year: lawItem?.year || null,
          fk_categoryId: lawItem.fk_categoryId || null,
        },
        attachments: {
          mainImage: lawItem?.attachment || null,
        },
        deleteMainImage: false,
        deletedAttachments: [],
      };

      setNewEvent(prefilledLaw);
      setIsAddingTeam(true);
      setCurrentLanguage(currentLanguage);
    } catch (error) {
      console.error("Error fetching law data:", error);
    }
  };

  const handleDeleteMainImage = (isDeleted) => {
    setNewEvent((prev) => ({
      ...prev,
      deleteMainImage: isDeleted, // ✅ Dynamically update promotionData
    }));
  };

  const handleDeleteAttachment = (language, attachmentId) => {
    setNewEvent((prev) => {
      const updatedDeletedAttachments = new Set(prev.deletedAttachments || []);

      // Add language to the Set if an attachment was deleted
      updatedDeletedAttachments.add(language);

      return {
        ...prev,
        deletedAttachments: Array.from(updatedDeletedAttachments), // Convert Set back to Array
      };
    });
  };

  const handleAddEvent = () => {
    setIsEditing(false);
    setSelectedCategory(null);
    setSelectedCategories(null);
    setRowToEdit(null);
    setMedia(null);
    setNewEvent({
      ar: { title: "", description: "", country: "", year: null },
      date: null,
      // attachments: null,
    });
    setCurrentLanguage(currentLanguage);
    setIsAddingTeam(true);
  };

  const handleSaveLanguage = () => {
    if (currentLanguage === "ar") {
      handleFinalizeEvent();
    } else {
      setConfirmationDialogOpen(true);
    }
  };

  const handleGlobalChange = (field, value) => {
    setNewEvent((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleProceedToNextLanguage = () => {
    setConfirmationDialogOpen(false);

    if (currentLanguage === "en") {
      setCurrentLanguage("fr");
    } else if (currentLanguage === "fr") {
      setCurrentLanguage("ar");
    }
  };

  const handleAttachmentsChange = (newAttachments) => {
    setNewEvent((prevNews) => {
      const prevAttachments = prevNews.attachments || {};
      return {
        ...prevNews,
        attachments: {
          ...prevAttachments,
          [`attachment_${currentLanguage}`]: newAttachments.report
            ? newAttachments.report
            : prevAttachments[`attachment_${currentLanguage}`],
          mainImage:
            newAttachments?.mainImage !== undefined
              ? newAttachments.mainImage
              : prevAttachments.mainImage || null,
        },
      };
    });
  };

  const handleFinalizeEvent = () => {
    let hasValidLanguageData = false;
    const payload = rowToEdit
      ? { id: typeof rowToEdit === "object" ? rowToEdit.id : rowToEdit }
      : {};
    Object.entries(newEvent).forEach(([lang, data]) => {
      if (["ar"].includes(lang)) {
        const hasData =
          data.title?.trim() ||
          data.description?.trim() ||
          data.country?.trim() ||
          data.year?.trim();

        if (hasData) {
          hasValidLanguageData = true;
          payload[lang] = {
            fk_categoryId:
              isEditing && selectedCategoriesEDIT
                ? selectedCategoriesEDIT.id || selectedCategoriesEDIT
                : selectedCategories?.id || null,
            title: data.title?.trim() || "",
            description: data.description?.trim() || "",
            country: data.country?.trim() || "",
            year: data?.year || null,
          };
        }
      }
    });

    ["ar"].forEach((lang) => {
      if (newEvent.attachments?.[`attachment_${lang}`]?.length) {
        files[`attachment_${lang}`] =
          newEvent.attachments[`attachment_${lang}`][0].file;
      }
    });

    if (newEvent.attachments?.mainImage) {
      files["mainImage"] = newEvent.attachments.mainImage[0].file;
    }

    if (rowToEdit && newEvent.deleteMainImage) {
      payload.deleteMainImage = true;
    }

    if (rowToEdit && newEvent.deletedAttachments?.length > 0) {
      payload.deletedAttachments = newEvent.deletedAttachments;
    }

    dispatch(saveLaw({ payload, sectionId, files }))
      .unwrap()
      .then(() => {
        setSelectedCategories();
        dispatch(fetchLaws({ companyId, page, limit: rowsPerPage }));
        setNewEvent({
          ar: {
            title: "",
            description: "",
            country: "",
            year: null,
          },
          date: null,
        });
        setConfirmationDialogOpen(false);
        setIsAddingTeam(false);
        setRowToEdit(null);
      })
      .catch((error) => {
        console.error("Error saving event:", error);
      });
  };

  const handleExitAndSave = () => {
    handleFinalizeEvent(); // Save the data
    setIsAddingTeam(false); // Close the form
    setConfirmationDialogOpen(false); // Close the dialog
  };

  const handleDeleteClick = (id, title) => {
    setPromotionIdToDelete(id);
    setDeleteDialogOpen(true);
    setDeleteTitle(title);
  };
  const confirmDelete = () => {
    dispatch(deleteSectionData({ id: promotionIdToDelete }))
      .then(() => {
        setDeleteDialogOpen(false);
        setPromotionIdToDelete(null);

        const updatedTotalRecords = Math.max(
          0,
          (lawsList?.pagination?.totalRecords ?? lawsList?.length ?? 0) - 1
        );
        const updatedTotalPages = Math.ceil(updatedTotalRecords / rowsPerPage);
        const newPage = Math.max(
          1,
          page > updatedTotalPages ? updatedTotalPages : page
        );

        setPage(newPage); // if using local page state

        dispatch(fetchLaws({ companyId, page: newPage, limit: rowsPerPage }));
      })
      .catch((error) => {
        console.error("Error deleting law:", error);
      });
  };

  const handleFilterChange = (selectedOption) => {
    dispatch(
      fetchLaws({
        companyId,
        page,
        limit: rowsPerPage,
        categoryId: selectedOption.id,
      })
    );
  };

  return (
    <StyledContainer>
      <Paper elevation={3} sx={{ padding: 3 }}>
        {!isAddingTeam && (
          <>
            <Typography variant="h5" sx={{ mb: 2 }}>
              Laws Section
            </Typography>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={6}>
                <StyledButton
                  variant="outlined"
                  startIcon={<AddIcon />}
                  onClick={handleAddEvent}
                  sx={{ marginBottom: 2 }}
                  disabled={loading}
                >
                  Add
                </StyledButton>
                <Box display="flex" alignItems="center" sx={{ mb: 2 }}>
                  <TextField
                    type="number"
                    label="Edit by ID"
                    variant="outlined"
                    value={rowToEdit}
                    onChange={(e) => setRowToEdit(e.target.value)}
                    size="small"
                    sx={{ marginRight: 1 }}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleEditLaw(parseInt(rowToEdit))}
                    disabled={!rowToEdit}
                  >
                    Edit
                  </Button>
                </Box>
              </Grid>
              <Grid item xs={6} display="flex" justifyContent="flex-end">
                <FilterButton
                  options={categories?.map((category) => ({
                    label: category.category_name,
                    id: category.id,
                  }))}
                  onFilterChange={handleFilterChange}
                  loading={loading}
                />
              </Grid>
            </Grid>

            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell
                      width={languagesList.length >= 2 ? "65%" : "80%"}
                    >
                      Title
                    </StyledTableCell>

                    <StyledTableCell width="15%">Actions</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(lawsList?.data || []).map((item) => (
                    <TableRow key={item.id}>
                      <TableCell>{item.title}</TableCell>{" "}
                      {/* Access `languages.en.title` */}
                      {/* Access `languages.en.brief` */}
                      <TableCell>
                        <IconButton onClick={() => handleEditLaw(item)}>
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          onClick={() => handleDeleteClick(item.id, item.title)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box mt={2} display="flex" justifyContent="center">
              <Pagination
                count={totalPages}
                page={page}
                onChange={handlePageChange}
                color="primary"
                size="large"
              />
            </Box>
          </>
        )}

        <Dialog
          open={deleteDialogOpen}
          onClose={() => setDeleteDialogOpen(false)}
        >
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete{" "}
              <span style={{ fontWeight: "bold" }}> {deleteTitle}</span>? This
              action cannot be undone.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
            <Button color="error" onClick={confirmDelete}>
              Delete
            </Button>
          </DialogActions>
        </Dialog>

        {isAddingTeam && (
          <Box>
            <Box display="flex" alignItems="center" gap={1} mb={2}>
              <IconButton onClick={() => setIsAddingTeam(false)}>
                <ArrowBackIcon />
              </IconButton>
              <Typography variant="h6">Law</Typography>
            </Box>
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Category</InputLabel>
              <Select
                value={isEditing ? selectedCategory : selectedCategories || ""}
                onChange={handleCategoryChange}
                renderValue={(selected) =>
                  selected ? (
                    <Chip
                      key={isEditing ? selected : selected.id}
                      label={isEditing ? selected : selected.category_name}
                    />
                  ) : (
                    ""
                  )
                }
              >
                {categories?.map((category) => (
                  <MenuItem key={category.id} value={category}>
                    {category.category_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {languagesList?.length > 1 && (
              <Tabs
                value={currentLanguage}
                indicatorColor="primary"
                textColor="primary"
                onChange={(e, newValue) => setCurrentLanguage(newValue)}
              >
                {languagesList?.map((lang) => (
                  <Tab key={lang.code} value={lang.code} label={lang.name} />
                ))}
              </Tabs>
            )}

            <TextField
              sx={{ mt: 1 }}
              label="Title"
              value={newEvent[currentLanguage]?.title || ""}
              onChange={(e) =>
                handleInputChange(currentLanguage, "title", e.target.value)
              }
              fullWidth
            />

            <ReactQuill
              key={currentLanguage}
              style={{
                marginTop: "20px",
                height: "300px",
                marginBottom: "60px",
              }}
              value={newEvent[currentLanguage]?.description || ""}
              onChange={(value) =>
                handleInputChange(currentLanguage, "description", value)
              }
              theme="snow"
              placeholder="Description..."
              modules={{
                toolbar: [
                  [{ header: "1" }, { header: "2" }, { font: [] }],
                  [{ list: "ordered" }, { list: "bullet" }],
                  ["bold", "italic", "underline"],
                  [{ align: [] }],
                  ["link"],
                  [{ color: [] }, { background: [] }],
                  ["clean"],
                ],
              }}
            />

            <TextField
              label="Country"
              value={newEvent[currentLanguage]?.country || ""}
              onChange={(e) =>
                handleInputChange(currentLanguage, "country", e.target.value)
              }
              fullWidth
            />

            <TextField
              type="number"
              sx={{ mt: 2 }}
              label="Year"
              value={newEvent[currentLanguage]?.year || null}
              onChange={(e) =>
                handleInputChange(currentLanguage, "year", e.target.value)
              }
              fullWidth
            />

            <Attachments
              onAttachmentsChange={handleAttachmentsChange}
              media={media}
              currentLanguage={currentLanguage}
              onDeleteMainImage={handleDeleteMainImage} // Pass delete flag handler
              onDeleteAttachment={handleDeleteAttachment} // Pass
            />

            <Box sx={{ mt: 8, display: "flex", justifyContent: "flex-end" }}>
              <Button
                onClick={() => setIsAddingTeam(false)}
                sx={{ marginRight: 2 }}
                color="error"
                variant="contained"
              >
                Cancel
              </Button>
              <Button
                onClick={handleExitAndSave}
                color="primary"
                variant="contained"
              >
                Save
              </Button>
            </Box>
          </Box>
        )}
      </Paper>
    </StyledContainer>
  );
}
